import * as React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import { getNextStep } from '../../../../actions/claimHistoryActionsV2';


class ClaimsNextStep extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick(id) {
        if (this.props.claimSubmit.canNavigateToNextStep == true) {
            this.props.handleGetNextStep();
        }
    }

    render() {
        var stepInfo = "";
        switch (this.props.claimSubmit.nextStepDescription) {
            case 'Notification of claim':
                stepInfo = "Let's register your claim";
                break;

            case 'Claim registration':
                stepInfo = "Let's register your claim";
                break;

            case 'Assessment':
                stepInfo = "Let’s take a look at your car’s damage, shall we";
                break;

            case 'Repairs':
                stepInfo = "Time to give your wheels some TLC";
                break;

            case 'Towing':
                stepInfo = "Right-o, now we need to tow your car";
                break;

            case 'Claim completed':
                stepInfo = "Yay, your claim's done and dusted";
                break;

            case 'Claim processing':
                stepInfo = "Oh looky, it's time to process your claim";
                break;

            default: stepInfo = '';
        }

        return (
            <>
                <div className={this.props.claimSubmit.canNavigateToNextStep ? " cursor-pointer row noma mt-10px" : " opacity-off " + "row noma mt-10px"}>
                    <div className="col nopa">
                        <Card className="content-box-padding-20px-with-box-shadow grey-border" onClick={this.handleClick}>
                            <Card.Body className="nopa">
                                <div className="row align-items-center">
                                    <div className="arrow-col text-center align-self-center">
                                        <img src="./images/Claims/ClaimsV2/icons-arrow-dropdown-right.png" />
                                    </div>
                                    {!isMobile &&
                                        <div className="col nopa align-self-center">
                                            <strong>{this.props.claimSubmit.nextStepDescription}    |</strong>  {stepInfo}
                                        </div>
                                    }
                                    {isMobile &&
                                        <div className="col nopa align-self-center">
                                            <strong>{this.props.claimSubmit.nextStepDescription}    </strong><br />  {stepInfo}
                                        </div>
                                    }
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </>
        )
    }
}


const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimsHistory: state.claimsHistory,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimsNextStep);
